export const PROPERTY_CHAT_BOT_TRIGGER = "propertyChatBotTrigger";
export const PROPERTY_CHAT_BOT_TRIGGER = "propertyChatBotTrigger";
